import * as prismic from "@prismicio/client";

export const repositoryName = "steve-writing-portfolio";

export const client = prismic.createClient(repositoryName);
